export const SET_TRACKING_ID = "SET_TRACKING_ID"
export const SET_USER_IMPORTS = "SET_USER_IMPORTS"
export const REQUEST_USER_IMPORTS = "REQUEST_USER_IMPORTS"
export const UPDATE_USER_IMPORTS = "UPDATE_USER_IMPORTS"

export const [PROCESSING, FAILURE, SUCCESS] = ["Processing", "Failure", "Success"];
export const [FACEBOOK, INSTAGRAM] = ["Facebook", 'Instagram'];